import { AsciiText } from '../framework/AsciiText';
export class NecMultisync {
    constructor(socket, log) {
        this.socket = socket;
        this.displayBlank = false;
        this.power = true;
        this.videoSelection = '17'; // HDMI 1 in decimal
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'displayBlankQuery',
                regExp: /\x010[\s\S]0C06\x0210B6\x03[\s\S]/i,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x01,
                        0x30,
                        0x30,
                        0x30,
                        0x44,
                        0x31,
                        0x32,
                        0x02,
                        0x30,
                        0x30,
                        0x31,
                        0x30,
                        0x42,
                        0x36,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x31,
                        0x30,
                        0x30,
                        0x30,
                        this.displayBlank ? 0x31 : 0x30,
                        0x03,
                    ]));
                },
            },
            {
                name: 'displayBlankSet',
                regExp: /\x010[\s\S]0E0A\x0210B6000([\s\S])\x03[\s\S]/i,
                callback: (match) => {
                    this.displayBlank = match[1] === '\x31';
                    this.socket.send(this.makeCommand([
                        0x01,
                        0x30,
                        0x30,
                        0x30,
                        0x46,
                        0x31,
                        0x32,
                        0x02,
                        0x30,
                        0x30,
                        0x10,
                        0x30,
                        0x42,
                        0x36,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        this.displayBlank ? 0x31 : 0x30,
                        0x03, // ETX end message
                    ]));
                },
            },
            {
                name: 'firmwareVersionQuery',
                regExp: /\x010[\s\S]0A08\x02CA0200\x03[\s\S]/i,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x01,
                        0x30,
                        0x30,
                        0x30,
                        0x42,
                        0x31,
                        0x38,
                        0x02,
                        0x43,
                        0x42,
                        0x30,
                        0x32,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x32,
                        0x32,
                        0x45,
                        0x30,
                        0x33,
                        0x30,
                        0x34,
                        0x30,
                        0x35,
                        0x34,
                        0x31,
                        0x34,
                        0x32,
                        0x03, // ETX
                    ]));
                },
            },
            {
                name: 'powerQuery',
                regExp: /\x01\x30[\s\S]0A06\x0201D6\x03[\s\S]/i,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x01,
                        0x30,
                        0x30,
                        0x30,
                        0x42,
                        0x31,
                        0x32,
                        0x02,
                        0x30,
                        0x32,
                        0x30,
                        0x30,
                        0x44,
                        0x36,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x34,
                        0x30,
                        0x30,
                        0x30,
                        this.power ? 0x31 : 0x34,
                        0x03, // ETX End of message
                    ]));
                },
            },
            {
                name: 'powerSet',
                regExp: /\x01\x30[\s\S]0A0C\x02C203D6000([\s\S])\x03[\s\S]/i,
                callback: (match) => {
                    this.power = match[1] === '\x31';
                    this.socket.send(this.makeCommand([
                        0x01,
                        0x30,
                        0x30,
                        0x30,
                        0x42,
                        0x30,
                        0x45,
                        0x02,
                        0x30,
                        0x30,
                        0x43,
                        0x32,
                        0x30,
                        0x33,
                        0x44,
                        0x36,
                        0x30,
                        0x30,
                        0x30,
                        this.power ? 0x31 : 0x34,
                        0x03, // ETX End of message
                    ]));
                },
            },
            {
                name: 'videoQuery',
                regExp: /\x010[\s\S]0C06\x020060\x03[\s\S]/i,
                callback: (match) => {
                    const videoBytes = this.createAsciiBytes(this.videoSelection, 4);
                    this.socket.send(this.makeCommand([
                        0x01,
                        0x30,
                        0x30,
                        0x30,
                        0x42,
                        0x31,
                        0x32,
                        0x02,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x36,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        ...videoBytes,
                        0x03, // ETX End of message
                    ]));
                },
            },
            {
                name: 'videoSet',
                regExp: /\x010[\s\S]0E0A\x020060([\s\S]{4})\x03[\s\S]/i,
                callback: (match) => {
                    // Convert hex string to decimal string
                    this.videoSelection = parseInt(match[1], 16).toString();
                    this.socket.send(this.makeCommand([
                        0x01,
                        0x30,
                        0x30,
                        0x30,
                        0x42,
                        0x31,
                        0x32,
                        0x02,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x36,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        match[1].charCodeAt(0),
                        match[1].charCodeAt(1),
                        match[1].charCodeAt(2),
                        match[1].charCodeAt(3),
                        0x03, // ETX End of message
                    ]));
                },
            },
            {
                name: 'volumeQuery',
                regExp: /\x010[\s\S]0C06\x020062\x03[\s\S]/i,
                callback: (match) => {
                    const volBytes = this.createAsciiBytes(this.volume.toString());
                    this.socket.send(this.makeCommand([
                        0x01,
                        0x30,
                        0x30,
                        0x30,
                        0x42,
                        0x31,
                        0x32,
                        0x02,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x36,
                        0x32,
                        0x30,
                        0x30,
                        0x30,
                        0x31,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        ...volBytes,
                        0x03, // ETX End of message
                    ]));
                },
            },
            {
                name: 'volumeSet',
                regExp: /\x010[\s\S]0E0A\x020062([\s\S]{4})\x03[\s\S]/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 16);
                    this.socket.send(this.makeCommand([
                        0x01,
                        0x30,
                        0x30,
                        0x30,
                        0x42,
                        0x31,
                        0x32,
                        0x02,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x36,
                        0x32,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x36,
                        0x34,
                        match[1].charCodeAt(0),
                        match[1].charCodeAt(1),
                        match[1].charCodeAt(2),
                        match[1].charCodeAt(3),
                        0x03, // ETX End of message
                    ]));
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /\x010[\s\S]0C06\x02008D\x03[\s\S]/i,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x01,
                        0x30,
                        0x30,
                        0x30,
                        // ToDo: value 'B' for command reply?
                        0x43,
                        0x31,
                        0x32,
                        0x02,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x38,
                        0x44,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        this.volumeMute ? 0x31 : 0x30,
                        0x03, // ETX End of message
                    ]));
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /\x010[\s\S]0E0A\x02008D000([\s\S])\x03[\s\S]/i,
                callback: (match) => {
                    this.volumeMute = match[1] === '\x31';
                    this.socket.send(this.makeCommand([
                        0x01,
                        0x30,
                        0x30,
                        0x30,
                        0x42,
                        0x31,
                        0x32,
                        0x02,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x38,
                        0x44,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        0x30,
                        this.volumeMute ? 0x31 : 0x30,
                        0x03, // ETX End of message
                    ]));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`401-`);
                },
            },
        ];
    }
    // Convert decimal string value to ascii hex values.
    //
    // 100d -> 0x64 -> [0x36, 0x34]
    // 11d -> 0x0b -> [0x30, 0x42]
    createAsciiBytes(input, len = 2) {
        const values = [];
        const codeValue = parseInt(input).toString(16).padStart(len, '0');
        for (let i = 0; i < codeValue.length; i++) {
            const value = parseInt(codeValue.substring(i, i + 1), 16);
            values.push(value < 10 ? 0x30 + value : 0x41 + value - 10);
        }
        return values;
    }
    makeCommand(data) {
        let checksum = 0;
        const bytes = data;
        // Compute the checksum.
        for (let i = 1; i < bytes.length; i++) {
            checksum ^= bytes[i];
        }
        bytes.push(checksum & 0x00ff); // Add the checksum to the command.
        return AsciiText.decode(bytes);
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            if (this.videoSelection === lowestCode)
                return;
            if (lowestCode === undefined ||
                parseInt(videoInput.code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = videoInput.code;
            }
        }
        lowestCode = (lowestCode !== null && lowestCode !== void 0 ? lowestCode : '11').padStart(2, '0');
        this.videoSelection = lowestCode;
    }
}
NecMultisync.emulatorType = 'socketEmulator';
NecMultisync.key = '-KHGvnz4v1sLsuUjJEDp';
